<template>
  <div>
    <l-button v-if="user.gender" :href="route('compass.action', 'start')" variant="primary" size="lg">
      <slot/>
    </l-button>

    <inline-edit
      v-else
      title="Set preferred pronoun"
      save-label="Save and continue to assessment"
      :action="route('settings.gender', { next: route('compass.action', 'start') })"
      v-bind="{ user }"
    >
      <template #activator="{ activator }">
        <l-button variant="primary" size="lg" @click="activator">
          <slot/>
        </l-button>
      </template>

      <l-select
        name="gender"
        :items="genders"
        label="Preferred pronoun"
        placeholder="Not indicated"
        required
      />
    </inline-edit>
  </div>
</template>

<script setup>
import InlineEdit from "@/components/inlines/InlineEdit.vue"
import LButton from "@/components/buttons/LButton.vue"
import LSelect from "@/components/inputs/LSelect.vue"
import route from "ziggy-js"
import { useGenders } from "@/composables/useGenders"

const user = defineModel({ type: Object, required: true })

const { genders } = useGenders()
</script>
